<template>
  <v-row class="fill-height">
    <v-col cols="12" md="5" lg="6" xl="5">
      <TitleAndSearch
        :icon="'icon_points_of_interest'"
        :title="'Mis Lugares'"
        :searchSize="8"
        :showSearch="showSearch"
      />
      <router-view />
    </v-col>
    <v-col cols="12" md="7" lg="6" xl="7">
      <Map class="lt-map elevation-2 rounded-lg" idMap="idLugaresMapa" />
      <MapUi />
    </v-col>
  </v-row>
</template>

<script>
import TitleAndSearch from '@/components/TitleAndSearch.vue'
import MapUi from '@/components/geofences/map/MapUi.vue'
import Map from '@/components/geofences/map/Map.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    Map,
    MapUi,
    TitleAndSearch
  },
  data() {
    return {
      showSearch: true
    }
  },
  methods: {
    ...mapActions('mapState', ['initMapState']),
    showSearchInput() {
      const currentRoute = this.$router.currentRoute
      if (currentRoute.name !== 'PointsList') {
        this.showSearch = false
      } else {
        this.showSearch = true
      }
    }
  },
  created() {
    this.initMapState()
    this.showSearchInput()
  },

  updated() {
    this.showSearchInput()
  }
}
</script>

<style lang="scss" scoped>
.lt-map {
  height: 100%;
  @media screen and (max-width: 960px) {
    height: 100vh;
  }
}
.fill-height-or-more {
  display: flex;
  flex-direction: column;
  > div {
    flex: 1;
  }
}
</style>
